<div class="modal-wrapper">
  <div class="modal-header">
    <h2 class="h6_500 modal-title" mat-dialog-title>
      {{ title | translate }}
    </h2>
    <common-icon-button
      class="modal-close-button"
      variant="plain"
      icon="close"
      iconSet="material-icons-outlined"
      ariaLabel="Close"
      color="weak"
      type="filled"
      size="small"
      [stopClickPropagation]="true"
      (output)="onEventClose()"
    ></common-icon-button>
  </div>

  <mat-dialog-content class="modal-content">
    <form [formGroup]="form" class="modal-form">
      <app-time-input-field
        class="modal-form-field"
        widthLayout="fill"
        [label]="inputLabel | translate"
        [minuteStep]="minuteStep"
        [required]="true"
        [formControl]="timeControl"
      ></app-time-input-field>
    </form>
  </mat-dialog-content>

  <mat-dialog-actions class="modal-actions">
    <common-buttons-outlined
      [label]="labelButtonCancel | translate"
      [disabled]="loading"
      [iconPosition]="false"
      (output)="onEventCancel()"
    ></common-buttons-outlined>

    <common-buttons-filled
      [label]="labelButtonSave | translate"
      [disabled]="loading || !form.valid"
      [iconPosition]="false"
      (output)="onEventSave()"
    ></common-buttons-filled>
  </mat-dialog-actions>
</div>

